import { createFileRoute } from '@tanstack/react-router';

import { GamepadLayoutScreen } from '@/pages/GamepadLayoutScreen.tsx';

export const Route = createFileRoute('/(app)/gamepadLayoutScreen')({
  component: GamepadLayoutScreen,
});
